import { useEffect, useState } from "react";
import { mostraAlertaError, mostraAlertaOk, mostraAlertaWarning } from "../../../../componentes/alerts/sweetAlert";
import { AxiosPrivado } from "../../../../componentes/axios/Axios";
import Dropzone from "../../../../componentes/imagenes/Dropzone";
import ModalBootstrap from "../../../../componentes/modal/ModalBootstrap";
import {
    ImagenTipoProducto,
    ProductosTiposEditar,
    ProductosTiposGuardar,
    ProductosTiposListar
} from "../../../../configuracion/apiUrls";
import { regexDescripcion, regexNombre } from "../../../../configuracion/validaciones";

const ModalTipoProducto = ({ datos, token, setListaTiposProductos, ActualizarLista }) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [id, setId] = useState(datos ? datos.id : null);
    const [nombre, setNombre] = useState(datos ? datos.nombre : '');
    const [descripcion, setDescripcion] = useState(datos ? datos.descripcion : '');
    const [estado, setEstado] = useState(datos ? datos.estado : 'Activo');
    const [errorNombre, setErrorNombre] = useState(false);
    const [imagen, setImagen] = useState(null);
    const [imagenPreviaUrl, setImagenPreviaUrl] = useState(null);
    const [eliminarImagenEnServidor, setEliminarImagenEnServidor] = useState(false);
    const [errorDescripcion, setErrorDescripcion] = useState(false);

    useEffect(() => {
        if (regexNombre.test(nombre))
            setErrorNombre(false)
        else
            setErrorNombre(true)
    }, [nombre])

    useEffect(() => {
        if (regexDescripcion.test(descripcion))
            setErrorDescripcion(false)
        else
            setErrorDescripcion(true)
    }, [descripcion])

    useEffect(() => {
        if (modalIsOpen) {
            setNombre(datos ? datos.nombre : '');
            setDescripcion(datos ? datos.descripcion : '');
            setEstado(datos ? datos.estado : 'Activo');
            setId(datos ? datos.id : null);
            setImagen(null);
            setEliminarImagenEnServidor(false);

            if (datos && datos.imagen) {
                setImagenPreviaUrl(ImagenTipoProducto + datos.imagen);
            } else {
                setImagenPreviaUrl(ImagenTipoProducto + "categoriasproductos.jpg");
            }
        }
    }, [modalIsOpen, datos])

    const BotonGuardar = () => {
        return (
            <button type="button" className="btn btn-success" onClick={guardarTipo}>Guardar</button>
        )
    }
    const BotonEditar = () => {
        return (
            <button type="button" className="btn btn-warning" onClick={editarTipo}>
                Editar
                <i className="fas fa-edit ml-3" />
            </button>
        )
    }

    const handleEliminarImagenPrevia = () => {
        setImagenPreviaUrl(null);
        setImagen(null);
        setEliminarImagenEnServidor(true);
    };

    const guardarTipo = async () => {
        if (errorNombre) {
            mostraAlertaWarning("El nombre del tipo debe tener entre 3 y 50 caracteres y solo puede contener letras");
        } else if (errorDescripcion) {
            mostraAlertaWarning("La descripción del tipo debe tener entre 9 y 150 caracteres");
        } else {
            try {
                const formData = new FormData();
                formData.append("nombre", nombre);
                formData.append("estado", estado);
                if (descripcion !== "") {
                    formData.append("descripcion", descripcion);
                }
                if (imagen) {
                    const file = Array.isArray(imagen) ? imagen[0] : imagen;
                    formData.append("imagen", file);
                } else {
                    formData.append("imagen", "categoriasproductos.jpg");
                }

                AxiosPrivado.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                await AxiosPrivado.post(ProductosTiposGuardar, formData, {
                    headers: { "Content-Type": "multipart/form-data" }
                })
                    .then((respuesta) => {
                        ActualizarLista(ProductosTiposListar, setListaTiposProductos);
                        mostraAlertaOk("Registro guardado correctamente");
                        setModalIsOpen(false);
                    })
                    .catch((er) => {
                        const { response } = er;
                        const msjError = response?.data?.msj || response?.data?.error?.message || "Ocurrió un error desconocido.";
                        mostraAlertaError(msjError, "error");
                    });
            } catch (error) {
                mostraAlertaError("Error en la petición");
            }
        }
    };

    const editarTipo = async () => {
        if (!id)
            mostraAlertaError("Seleccione un cargo");
        else if (errorNombre) {
            mostraAlertaWarning("El nombre del cargo debe tener entre 3 y 50 caracteres");
        } else if (errorDescripcion) {
            mostraAlertaWarning("La descripción del tipo debe tener entre 9 y 150 caracteres");
        } else {
            try {
                const formData = new FormData();
                formData.append("nombre", nombre);
                formData.append("estado", estado);
                if (descripcion !== "") {
                    formData.append("descripcion", descripcion);
                }

                if (imagen) {
                    const file = Array.isArray(imagen) ? imagen[0] : imagen;
                    formData.append("imagen", file);
                } else if (eliminarImagenEnServidor) {
                    formData.append("eliminarImagen", true);
                } else if (!datos.imagen && !imagenPreviaUrl) {
                    formData.append("imagen", "categoriasproductos.jpg");
                }

                AxiosPrivado.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                await AxiosPrivado.put(ProductosTiposEditar + id, formData, {
                    headers: { "Content-Type": "multipart/form-data" }
                })
                    .then((respuesta) => {
                        ActualizarLista(ProductosTiposListar, setListaTiposProductos);
                        mostraAlertaOk("Registro actualizado correctamente");
                        setModalIsOpen(false);
                    })
                    .catch((er) => {
                        const { response } = er;
                        const msjError = response?.data?.msj || response?.data?.error?.message || "Ocurrió un error desconocido.";
                        mostraAlertaError(msjError, "error");
                    });
            } catch (error) {
                mostraAlertaError("Error en la petición");
            }
        }
    };

    return (
        <ModalBootstrap
            titulo={datos ? "Editar Tipo" : "Nuevo Tipo"}
            nombreBoton={datos ? "" : "Nuevo Tipo"}
            estiloBoton={datos ? "btn btn-outline-primary" : "btn btn-info"}
            iconBoton={datos ? "fas fa-edit mx-0" : "fas fa-briefcase"}
            pie={datos ? <BotonEditar /> : <BotonGuardar />}
            modalIsOpen={modalIsOpen}
            setModalIsOpen={setModalIsOpen}
            size={'sx'}
        >
            <div className="row">
                <div className="col-sm-12">
                    <div className="form-group">
                        <label htmlFor="primerNombre">Nombre</label>
                        <input
                            type="text"
                            className={`form-control ${errorNombre ? "is-invalid" : ""}`}
                            id="text"
                            placeholder="Nombre"
                            name="nombre"
                            value={nombre}
                            onChange={e => setNombre(e.target.value)}
                        />
                        <span id="nombre_cargo-error" className="error invalid-feedback">
                            El nombre del tipo debe tener entre 3 y 50 caracteres y solo puede contener letras
                        </span>
                    </div>
                </div>
                <div className="col-sm-12">
                    <div className="form-group">
                        <label htmlFor="descripcion">Descripción</label>
                        <textarea
                            type="text"
                            className={`form-control ${errorDescripcion ? "is-invalid" : ""}`}
                            placeholder="Escribe la descripción"
                            name="descripcion"
                            rows="3"
                            value={descripcion}
                            onChange={e => setDescripcion(e.target.value)}
                        />
                        <span id="descripcion-error" className="error invalid-feedback">
                            La descripción debe tener entre 9 y 150 caracteres
                        </span>

                    </div>
                </div>
                <div className="col-lg-4 col-sm-12">
                    <div className="form-group">
                        <label htmlFor="activo">
                            Estado
                        </label>
                        <div className="custom-control custom-switch custom-switch-off-danger custom-switch-on-success">
                            <input
                                type="checkbox"
                                className="custom-control-input"
                                id="customSwitch3"
                                name="activo"
                                checked={estado == "Activo" ? true : false}
                                onChange={(event) => {
                                    setEstado(event.target.checked ? "Activo" : "Inactivo")
                                }}
                            />
                            <label
                                className="custom-control-label"
                                htmlFor="customSwitch3"
                            >
                                {estado}
                            </label>
                        </div>
                    </div>
                </div>
                <div className="col-sm-12">
                    <div className="form-group">
                        <label htmlFor="imagen">
                            Imagen
                        </label>

                        {imagenPreviaUrl && (
                            <div className="position-relative mb-3" style={{ width: "100px" }}>
                                <img src={imagenPreviaUrl} className="img-thumbnail" alt="Imagen Previa" />
                                <button
                                    type="button"
                                    className="btn btn-danger btn-sm position-absolute"
                                    style={{ top: "5px", right: "5px", borderRadius: "50%" }}
                                    onClick={handleEliminarImagenPrevia}>
                                    ✖
                                </button>
                            </div>
                        )}

                        <div className="custom-control custom-switch custom-switch-off-danger custom-switch-on-success">
                            <Dropzone
                                max={1}
                                files={imagen}
                                setFiles={setImagen}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </ModalBootstrap>
    );
}
export default ModalTipoProducto;